import React from 'react';
import {
    makeStyles,
    tokens,
    Button,
    Menu,
    MenuTrigger,
    MenuPopover,
} from '@fluentui/react-components';
import { observer } from 'owa-mobx-react';
import { isFeatureEnabled } from 'owa-feature-flags';
import fileButtonStrings from './fileButton.locstring.json';
import loc from 'owa-localize';

interface FileButtonProps {
    menuContent: React.ReactNode;
    label?: string;
}

export const FileButton: React.FunctionComponent<FileButtonProps> = observer(
    ({ menuContent, label }) => {
        const fileLabel = label || loc(fileButtonStrings.FileButton);
        const { button } = useStyles();

        if (!isFeatureEnabled('mon-ribbon-file-tab')) {
            return null;
        }

        return (
            <Menu>
                <MenuTrigger>
                    <Button appearance="transparent" className={button}>
                        {fileLabel}
                    </Button>
                </MenuTrigger>
                <MenuPopover>{menuContent}</MenuPopover>
            </Menu>
        );
    },
    'FileButton'
);

const useStyles = makeStyles({
    button: {
        fontWeight: tokens.fontWeightRegular,
        height: '32px',
        marginLeft: '3px',
        marginRight: '2px',
        minWidth: 'auto',
        padding: `0 ${tokens.spacingHorizontalMNudge}`,
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground2Hover,
            color: tokens.colorNeutralForeground1,
        },
    },
});
